const delivery = {
  show({ orderId }, delay = 100) {
    setTimeout(() => {
      globalThis.$events.$emit("delivery-modal", { orderId });
    }, delay);
  },

  dismiss() {
    globalThis.$events.$emit("delivery-modal");
  },
};

globalThis.$delivery = delivery;

export default {
  install(Vue) {
    Vue.prototype.$delivery = delivery;
  },
};
